import React from "react";
import styled from "styled-components";

const Text = (props) => {
  return (
    <CustomText {...props} style={props.style} className={props.className}>
      {props.children}
    </CustomText>
  );
};

export const CustomText = styled.p`
  font-family: ${({ fontFamily, theme }) => fontFamily || theme.fonts.primary};
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => size};
  color: ${({ color }) => color};
`;

export default Text;
